<template>
  <div class="car-content car-main-tab-content car-reduced-width">
    <div class="car-booking car-booking-confirmed" v-if="booking && booking.searchConfig && booking.latest && booking.latest.bookedOfferDetail">
      <div class="car-content-introduction">
        <span class="car-headline">
          {{$t('quote.appointment.confirmed')}}
        </span>
        <p>
          {{$t('quote.appointment.confirmedDescription')}}
        </p>
        <p class="car-complimentary-close">
          {{$t('quote.appointment.complimentaryClose')}}
        </p>
        <p class="car-signature">
          {{$t('quote.appointment.signature')}}
        </p>
      </div>

      <div class="car-accordion-container">
        <accordion class="car-accordion-offer-details" :label="$t('accordion.bookingDetails')" :expand="false" v-if="booking && booking.searchConfig && booking.latest && booking.latest.bookedOfferDetail">
          <div class="car-offer-details">

            <time-slot :timeslot="timeslot" />

            <div class="car-selected-services">
              <span class="car-label">
                {{$t('quote.serviceLabel')}}
              </span>
              <offer-service-selection
                :sections="selectedServices"
                :is-disabled="true"
                :allSections="booking.latest.bookedOfferDetail.actualSections.sections"
                :hide-prices="hideCalculation" />
            </div>

            <div class="car-price-details">
              <div class="car-items">
                <div class="car-item">
                  <accordion v-if="!hideCalculation" :logo="true" data-js="booking_calculation" :label="$t('quote.calculation.calculation')" :class="car-accordion-price-details">
                    <offer-services-review
                      data-js="detail__offer--review"
                      :bookingServices="booking.bookingServices"
                      :valuatedVehicle="booking.searchConfig.vehicleConfig"
                      :selectedOffer="booking.latest.bookedOfferDetail"
                      :selectedServices="booking.searchConfig.services"
                      :actualNetRate="booking.latest.bookedOfferDetail.actualNetPrice"
                      :actualGrossRate="booking.latest.bookedOfferDetail.actualGrossPrice"
                      :regularGrossRate="booking.latest.bookedOfferDetail.regularGrossPrice"
                      :discountedNetPrice="booking.latest.bookedOfferDetail.discountedNetPrice"
                      :discountedGrossPrice="booking.latest.bookedOfferDetail.discountedGrossPrice"
                      :maintenancePositions="[]"
                    />
                  </accordion>
                </div>
              </div>
            </div>

            <div v-if="!hideCalculation" class="car-offer-price">
              <div class="car-items">
                <div class="car-item">
                  <span class="car-label">{{$t('quote.price', {tax: booking.latest.bookedOfferDetail.salesTax})}}</span>
                  <span class="car-price" data-js="booking_price--container">
                    {{ booking.latest.bookedOfferDetail.discountedGrossPrice | currency}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </accordion>
        <accordion class="car-accordion-workshop" :label="$t('accordion.workshop')" :expand="false">
          <workshop-details :location-id="booking.locationId" :expand="true"/>
        </accordion>
        <accordion class="car-accordion-vehicle" :label="$t('accordion.vehicle')">
          <vehicle-details :vehicle="getVehicle()"/>
        </accordion>
        <accordion class="car-accordion-user" :label="$t('accordion.user')" data-js="user_details">
          <customer-details :booking="booking"/>
        </accordion>
        <accordion class="car-accordion-user-ratings" data-js="user_ratings" :label="$t('accordion.ratings')" v-if="booking.comments && booking.comments.length">
          <workshop-review :location-id="booking.locationId"></workshop-review>
        </accordion>
      </div>
    </div>
    <spinner v-else-if="loading" class="car-spinner car-main-content-spinner" />
    <div v-else class="car-error-message">{{ $t('errors.unknown') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OfferServicesReview from '@/components/service-request/OfferServicesReview';
import Spinner from 'vue-simple-spinner';
import { filter, get } from 'lodash'
import Accordion from '@/components/Accordion';
import VehicleDetails from '@/components/service-request/VehicleDetails';
import WorkshopDetails from '@/components/service-request/WorkshopDetails';
import CustomerDetails from '@/components/service-request/CustomerDetails';
import WorkshopReview from '@/components/service-request/WorkshopReview';
import OfferServiceSelection from '@/components/service-request/OfferServiceSelection';
import TimeSlot from '@/components/TimeSlot';
import SMP_CONFIG from '@/util/smp_config';

export default {
  name: 'Confirmed',
  data() {
    return {
      loading: false,
      requestErr: false
    }
  },
  created() {
    this.loading = true;
    this.requestErr = false;
    this.$store.dispatch('offer/getBookingDetails', this.$route.params.key)
      .catch(() => { this.requestErr = true; })
      .finally(() => { this.loading = false; })
  },
  methods: {
    gotoMessage() {
      this.$router.push({ path: '/conversation' });
    },
    getVehicle() {
      let vehicleConfig = this.booking.latest.searchConfig.vehicleConfig;
      vehicleConfig.selectedEquipments = filter(vehicleConfig.vehicleTypeEquipmentList, 'selected');
      return vehicleConfig;
    }
  },
  computed: {
    ...mapGetters('offer', ['booking']),
    selectedServices() {
      return get(this, 'booking.latest.bookedOfferDetail.actualSections.sections', []).filter(service => service.serviceType !== 'ADDITIONAL');
    },
    timeslot() {
      return {
        dateFrom: this.booking.dropoffFrom.time,
        dateTo: this.booking.dropoffTo.time
      }
    },
    location() {
      return {
        name: this.booking.locationName,
        address: this.booking.locationAddress
      }
    },
    hideCalculation() {
      return get(SMP_CONFIG, 'contextConfig.extended.featureConfig.servicePriceDisplay', 'visible') === 'not_visible';
    }
  },
  components: {
    Spinner,
    Accordion,
    CustomerDetails,
    OfferServicesReview,
    VehicleDetails,
    WorkshopDetails,
    WorkshopReview,
    OfferServiceSelection,
    TimeSlot
  }
};
</script>
